const CERTIFICATE_EDITOR_WIDTH = 711;
const CERTIFICATE_EDITOR_HEIGHT = 502;

export { CERTIFICATE_EDITOR_WIDTH, CERTIFICATE_EDITOR_HEIGHT };
